import axios from "axios";
// не успел на всем сайте поправить
const http = axios.create({
  baseURL: ''
});

//https://777xbet.net

export default http